import { render, staticRenderFns } from "./VmLiveMigrateCancel.vue?vue&type=template&id=7b4b2526&"
import script from "./VmLiveMigrateCancel.vue?vue&type=script&lang=js&"
export * from "./VmLiveMigrateCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports